/* Umbrella Union — global queue player engine.
   One persistent bottom bar (#uu-pbar), one <audio data-uu-audio>.
   Reads a queue from #uu-hp-queue (JSON) if present, or via UU_PLAYER.setQueue().
   Any [data-uu-q="N"] element plays queue item N on click.
   Registers with the aa-media-coordinator for the global single-lock (audio + YouTube). */
(function () {
  'use strict';
  if (window.UU_PLAYER) return;
  var bar, audio, imgEl, titleEl, artistEl, linkEl, scrub, curEl, durEl, listEl, listBtn, posEl;
  var q = [], idx = -1, ready = false, shuffleMode = false;
  function $(id){ return document.getElementById(id); }
  function fmt(s){ s = Math.floor(s || 0); var m = Math.floor(s / 60), ss = s % 60; return m + ':' + (ss < 10 ? '0' : '') + ss; }

  function mark(){
    var playing = audio && !audio.paused;
    document.querySelectorAll('[data-uu-q]').forEach(function (b) {
      var on = parseInt(b.getAttribute('data-uu-q'), 10) === idx;
      b.classList.toggle('is-active', on);
      b.classList.toggle('is-playing', on && playing);
    });
  }
  function syncMulti(){
    if (!bar) return;
    bar.classList.toggle('uu-pbar--multi', q.length > 1);
    if (posEl) posEl.textContent = (q.length > 1 && idx >= 0) ? ((idx + 1) + ' / ' + q.length) : '';
    if (q.length < 2) closeList();
  }
  function buildList(){
    if (!listEl) return;
    listEl.textContent = '';
    q.forEach(function (t, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'uu-pbar__item'; b.setAttribute('data-uu-q', i);
      var n = document.createElement('span'); n.className = 'uu-pbar__inum'; n.textContent = i + 1;
      var ti = document.createElement('span'); ti.className = 'uu-pbar__ititle'; ti.textContent = t.title || '';
      var ar = document.createElement('span'); ar.className = 'uu-pbar__iartist'; ar.textContent = t.artist || '';
      b.appendChild(n); b.appendChild(ti); b.appendChild(ar);
      listEl.appendChild(b);
    });
    mark();
  }
  function closeList(){ if (listEl && !listEl.hidden) { listEl.hidden = true; bar.classList.remove('uu-pbar--list'); if (listBtn) listBtn.setAttribute('aria-expanded', 'false'); } }
  function toggleList(){
    if (!listEl) return;
    if (listEl.hidden) { buildList(); listEl.hidden = false; bar.classList.add('uu-pbar--list'); if (listBtn) listBtn.setAttribute('aria-expanded', 'true'); }
    else closeList();
  }
  function load(i){
    if (!q.length) return;
    idx = ((i % q.length) + q.length) % q.length;
    var t = q[idx]; if (!t) return;
    bar.hidden = false; document.body.classList.add('uu-has-player');
    if (imgEl) { imgEl.src = t.img || ''; imgEl.alt = t.title || ''; }
    if (titleEl) titleEl.textContent = t.title || '';
    if (artistEl) artistEl.textContent = t.artist || '';
    if (linkEl) linkEl.href = t.url || '#';
    if (t.src) audio.src = t.src;
    syncMulti();
    mark();
  }
  function play(i){
    if (i != null && i !== idx) load(i); else if (idx < 0) load(0);
    if (!audio.src) return;
    var p = audio.play(); if (p && p.catch) p.catch(function () {});
  }
  function toggle(){ if (idx < 0) { play(0); return; } if (audio.paused) audio.play(); else audio.pause(); }
  function next(){ if (shuffleMode && q.length > 1) { var n; do { n = Math.floor(Math.random() * q.length); } while (n === idx); play(n); } else { play(idx + 1); } }
  function shuffle(){ shuffleMode = true; if (!q.length) return; play(Math.floor(Math.random() * q.length)); }
  function prev(){ if (audio.currentTime > 3) audio.currentTime = 0; else play(idx - 1); }

  function init(){
    bar = $('uu-pbar'); if (!bar || ready) return; ready = true;
    audio = $('uu-pbar-audio'); imgEl = $('uu-pbar-img'); titleEl = $('uu-pbar-title');
    artistEl = $('uu-pbar-artist'); linkEl = $('uu-pbar-link'); scrub = $('uu-pbar-scrub');
    curEl = $('uu-pbar-cur'); durEl = $('uu-pbar-dur');
    listEl = $('uu-pbar-list'); listBtn = $('uu-pbar-list-btn'); posEl = $('uu-pbar-pos');
    var prevB = $('uu-pbar-prev'), nextB = $('uu-pbar-next'), ppB = $('uu-pbar-play'), closeB = $('uu-pbar-close');
    if (listBtn) listBtn.addEventListener('click', toggleList);
    if (listEl) listEl.addEventListener('click', function (e) { if (e.target.closest('[data-uu-q]')) setTimeout(closeList, 150); });
    if (prevB) prevB.addEventListener('click', prev);
    if (nextB) nextB.addEventListener('click', next);
    if (ppB) ppB.addEventListener('click', toggle);
    if (closeB) closeB.addEventListener('click', function () { audio.pause(); closeList(); bar.hidden = true; document.body.classList.remove('uu-has-player'); });
    audio.addEventListener('timeupdate', function () {
      if (audio.duration) { if (scrub) scrub.value = (audio.currentTime / audio.duration) * 100; if (curEl) curEl.textContent = fmt(audio.currentTime); }
      if (durEl && audio.duration) durEl.textContent = fmt(audio.duration);
    });
    audio.addEventListener('ended', next);
    audio.addEventListener('play', function () { bar.classList.add('is-playing'); mark(); });
    audio.addEventListener('pause', function () { bar.classList.remove('is-playing'); mark(); });
    if (scrub) scrub.addEventListener('input', function () { if (audio.duration) audio.currentTime = (scrub.value / 100) * audio.duration; });

    // queue from page (home)
    var qd = $('uu-hp-queue');
    if (qd) { try { q = JSON.parse(qd.textContent) || []; } catch (e) {} }

    // delegated play triggers
    document.addEventListener('click', function (e) {
      var sh = e.target.closest('[data-uu-shuffle]');
      if (sh) { e.preventDefault(); shuffle(); return; }
      var t = e.target.closest('[data-uu-q]');
      if (t) { e.preventDefault(); shuffleMode = false; play(parseInt(t.getAttribute('data-uu-q'), 10)); }
    });

    // global single-lock
    try { var c = window.UmbrellaUnion && window.UmbrellaUnion.aaMediaCoordinator; if (c) c.registerSection('uu-global-player', { root: bar }); } catch (e) {}
  }

  window.UU_PLAYER = {
    // a NEW queue invalidates the playhead position — without this, setQueue()+play(0) when idx
    // was already 0 skipped load() and kept the OLD audio playing (the Jul-6 crate-desync bug)
    setQueue: function (arr) { q = arr || []; idx = -1; syncMulti(); if (listEl && !listEl.hidden) buildList(); mark(); },
    play: play, toggle: toggle, next: next, prev: prev, shuffle: shuffle,
    get index(){ return idx; }, get queue(){ return q; }
  };
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
